import React from "react";
import { Container, Typography, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/dashboard");
  };

  return (
    <Container maxWidth="sm" sx={{ textAlign: "center", padding: "4rem 0" }}>
      <Typography variant="h1" component="h1" gutterBottom>
        404
      </Typography>
      <Typography variant="h4" component="h2" gutterBottom>
        Page Not Found
      </Typography>
      <Typography variant="body1" component="p" gutterBottom>
        Sorry, the page you're looking for doesn't exist.
      </Typography>
    </Container>
  );
};

export default NotFoundPage;
